import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    if (error.message && error.message.includes('forEach')) {
      // Ignore forEach errors from EntryManager
      return { hasError: false };
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error but don't crash the app for forEach errors
    if (error.message && error.message.includes('forEach')) {
      console.warn('EntryManager forEach error suppressed:', error.message);
      this.setState({ hasError: false });
      return;
    }
    console.error('ErrorBoundary caught an error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return <div>Something went wrong.</div>;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;